/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamtemplates1Inputs */

const en_entity_teamtemplates1 = /** @type {(inputs: Entity_Teamtemplates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Templates`)
};

const de_entity_teamtemplates1 = /** @type {(inputs: Entity_Teamtemplates1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen`)
};

/**
* | output |
* | --- |
* | "Team Templates" |
*
* @param {Entity_Teamtemplates1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamtemplates1 = /** @type {((inputs?: Entity_Teamtemplates1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamtemplates1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamtemplates1(inputs)
	return de_entity_teamtemplates1(inputs)
});
export { entity_teamtemplates1 as "entity_teamTemplates" }